const REFRESH_SESSION_HINT_KEY = 'auth_refresh_session';

export const hasRefreshSessionHint = () => {
  return localStorage.getItem(REFRESH_SESSION_HINT_KEY) === '1';
};

export const markRefreshSessionHint = () => {
  localStorage.setItem(REFRESH_SESSION_HINT_KEY, '1');
};

export const clearRefreshSessionHint = () => {
  localStorage.removeItem(REFRESH_SESSION_HINT_KEY);
};
